class ModalAdminLayout {
  constructor (opts) {
    const that = this;

    this.opts = $.extend(
      {
        id: null,
        data: null,
        baseUrl: INKIVE.C.BASE_URL,
        staticUrl: INKIVE.C.STATIC_URL,

        text_name: 'Layout name',
        text_tags: 'Tags',
        text_active: 'Active',
        text_premium: 'Premium',
        text_format:
          (INKIVE.C.MODE.IS_DESYGNER ? 'Design' : 'Page') + ' format',
        text_set: 'Priority',
        text_name_tooltip:
          "<b>Name</b><br />Make sure that you insert right name. Don't use white-space and special characters except hypen(-) and undersocre(_)",
        text_tags_tooltip:
          "<b>Tag - Sub filter</b><br />Seperate using comma(,) and don't use any special characters. ex) Blue, Snack, Cookie",
        text_set_tooltip:
          '<b>Priority</b><br />0 is most important and the number getting biger than will get less importantance. 0 will be shown in first list.'
      },
      opts
    );

    this.$wrapper = $(
      this.opts.wrapper
        ? $.parseHTML(this.opts.wrapper)
        : $.parseHTML('<div class="tool-content"></div>')
    );

    setData(null);

    loadData(function () {
      initTemplate();
      initLayoutType(that.data);
      initData(that.data);
    });

    /** ** Private methods *********************************************************************************************/

    function setData (data) {
      that.data = data;

      if (data) {
        // Store some old values which are needed for page auto scale
        that.data.old_format_id = data.format_id;
        that.data.old_format_width = data.format_width;
        that.data.old_format_height = data.format_height;
      }
    }

    function initTemplate () {
      const html =
        '<div class ="main-content" style="display: table; width:100%">' +
        '<div style="display: table-cell; width:135px; vertical-align: top; "><section>' +
        '<img src="' +
        INKIVE.C.THUMB_NOCOVER +
        '" style="margin-bottom: 32px;border: 1px solid rgb(49, 61, 67); width: 110px;"/>' +
        '<div class="checkbox"><input type="checkbox" name="is_active"/>' +
        '<label for="is_active">' +
        that.opts.text_active +
        '</label></div>' +
        '<div class="checkbox"><input type="checkbox" name="is_premium"/>' +
        '<label for="is_premium">' +
        that.opts.text_premium +
        '</label></div>' +
        '</section></div>' +
        '<div style="display: table-cell; vertical-align: top;">' +
        '<section><input type="text" name="name" class="form-control" data-popover="tooltip" data-original-title="' +
        that.opts.text_name_tooltip +
        '" placeholder="' +
        that.opts.text_name +
        '"/></section>' +
        '<div data-popover="tooltip" data-original-title="' +
        that.opts.text_tags_tooltip +
        '"><input type="text" name="tags" data-role="tagsinput" placeholder="' +
        that.opts.text_tags +
        '"/></div>' +
        '<div style="display: table; width:100%">' +
        '<div style="display: table-cell; vertical-align: top;"><input type="text" name="set" data-role="tagsinput" data-popover="tooltip" data-original-title="' +
        that.opts.text_set_tooltip +
        '" placeholder="' +
        that.opts.text_set +
        '"/></div>' +
        '</div>' +
        '<div id="admin-page-format-selction"><section class="ui-dropdown"><label>' +
        that.opts.text_format +
        '</label><div class="input-icon"><div id="layout_format">' +
        that.opts.text_format +
        '</div><i class="desygner-icon-unfold_more"></i></div>' +
        '<ul id="options" class="ui-dropdown-items" style="height: 100px;"></ul><input name="layout_format" type="hidden"/></section>' +
        '<input type="hidden" name="format_width"/>' +
        '<input type="hidden" name="format_height"/>' +
        '</div>' +
        '<div id ="admin-page-redirect-link">' +
        '<section class="ui-dropdown">' +
        '<input type="hidden" name="id"/>' +
        '<input type="hidden" name="format_width"/>' +
        '<input type="hidden" name="format_height"/></section>' +
        '</div>' +
        '</div>' +
        '</div>';

      that.$wrapper.append($.parseHTML(html));

      that.$wrapper.find('[data-popover="tooltip"]').tooltip({
        placement: 'auto',
        html: true
      });

      that.$wrapper.trigger('contentChanged');
    }

    function initLayoutType (data) {
      const $target = that.$wrapper.find('.filterWrapper');

      function showParent ($element) {
        $element.addClass('active');
        const $parent = $element.parent();
        $parent.show();

        const level = parseInt($parent.attr('data-level'));
        const parent = $parent.attr('data-parent');

        if (level) {
          showParent(
            $target.find('li.filter-menu-item[data-type="' + parent + '"]')
          );
        }
      }

      function insert (level, object, parent) {
        parent = parent || '';

        const sz_class = level == 1 ? 'three-col' : 'small-col';
        const filterElem = $.parseHTML(
          '<ul class="filter ' +
            sz_class +
            '" data-level="' +
            level +
            '" data-parent="' +
            parent +
            '"></ul>'
        );
        $target.append(filterElem);
        if (level > 0) $(filterElem).hide();

        for (const name in object) {
          const names = $.isArray(object[name]) ? object[name] : [object[name]];
          const element = $.parseHTML(
            '<li class="filter-menu-item" data-type="' +
              name +
              '" data-type-id="' +
              names[0] +
              '">' +
              name +
              '</li>'
          );
          $(filterElem).append(element);

          if (
            Object.prototype.toString.call(object[name]) == '[object Object]'
          ) {
            insert(level + 1, object[name], name);
          }

          $(filterElem)
            .find('li.filter-menu-item[data-type="' + name + '"]')
            .on('click', function (e) {
              const $parent = $(this).parent();
              const level = parseInt($parent.attr('data-level'));
              const type = $(this).attr('data-type');
              $(this)
                .parent()
                .find('li.filter-menu-item')
                .removeClass('active');
              $(this).addClass('active');

              const $parents = $target
                .find('ul[data-level]')
                .filter(function () {
                  return parseInt($(this).attr('data-level')) > level;
                })
                .hide();
              $parents.hide();
              $parents.find('li.filter-menu-item').removeClass('active');
              $target.find('ul[data-parent="' + type + '"]').show();

              $target.data('value', $(this).attr('data-type-id'));

              that.$wrapper.trigger('contentChanged');
            });

          // Default data
          if (data.type) {
            if (jQuery.inArray(data.type, names) >= 0) {
              $target.data('value', names[0]);
              const $element = $target.find(
                'li.filter-menu-item[data-type="' + name + '"]'
              );
              showParent($element);
              that.$wrapper.trigger('contentChanged');
            }
          }
        }
      }

      // insert( 0, INKIVE.C.LayoutFilter );
    }

    function initData (data) {
      // Thumb
      const $img = that.$wrapper.find('img');
      $img.hide();
      INKIVE.Helpers.imageLoader(data.url, function (status, img) {
        if (status == INKIVE.C.Status.success) {
          $img.attr('src', data.url).fadeIn('slow');
        } else $img.attr('src', INKIVE.C.THUMB_NOCOVER).fadeIn('slow');
      });

      // Disable page format if layout exists
      if (data.id) {
        that.$wrapper.find('#admin-page-format-selction').addClass('disabled');
      }

      // Name
      const $name = that.$wrapper.find('[name="name"]');
      if (data.name) $name.val(data.name);
      $name.keyup(function (event) {
        const text = $(this).val();
        $(this).val(
          text
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9\-\_]/g, '')
        );
      });

      // Redirect Link
      const $id = that.$wrapper.find('[name="id"]');
      if (data.id) $id.val(data.id);

      const $redirectWidth = that.$wrapper.find('[name="format_width"]');
      if (data.format_width) $redirectWidth.val(data.format_width);

      const $redirectHeight = that.$wrapper.find('[name="format_height"]');
      if (data.format_height) $redirectHeight.val(data.format_height);

      const encodeLink = Base64.encode(
        '?d=desygner&width=' +
          $redirectWidth.val() +
          '&height=' +
          $redirectHeight.val() +
          '&t=' +
          $id.val() +
          '&unit=px'
      );

      const redirectLink =
        '<input class="redirect-link" type="text" value="' +
        that.opts.baseUrl +
        'discover/create?redirect=' +
        encodeLink +
        '" >';

      if ($id.val() !== 0) {
        $('.main-content').after(redirectLink);
      }

      $('.redirect-link').on('click', function (evt) {
        evt.preventDefault();
        $(this).select();
        document.execCommand('copy');

        if ($('.success-copy').length == 0) {
          const successCopy =
            '<div class="success-copy" style="text-align: center; margin-top: 8px;">Copied <i class="fa fa-check" aria-hidden="true"></i></div>';
          $('.redirect-link').after(successCopy);
        }

        setTimeout(function () {
          $('.success-copy').remove();
        }, 2000);
      });

      // Set
      const $set = that.$wrapper.find('[name="set"]');
      if (data.set) $set.val(data.set);
      $set.keyup(function (event) {
        const text = $(this).val();
        $(this).val(text.trim().replace(/[^0-9]/g, ''));
      });

      // Tags
      const $tags = that.$wrapper.find('[name="tags"]');
      $tags.tagsinput({ itemValue: 'id', itemText: 'name' });

      if (data.tag) {
        $.each(data.tag.split(','), function (index, tag) {
          $tags.tagsinput('add', { id: tag, name: tag });
        });
        that.$wrapper.trigger('contentChanged');
      }

      $tags.tagsinput('input').keyup(function (event) {
        const keycode = event.keyCode ? event.keyCode : event.which;
        let text = $(this).val();
        text = text.replace(/[^a-zA-Z0-9, ]/g, '');
        $(this).val(text);

        if (keycode == 13 || keycode == 188) {
          text = text.trim().replace(/,/g, '');
          $tags.tagsinput('add', { id: text, name: text });
          $tags.tagsinput('input').val('');
        }
      });

      $tags.tagsinput('input').change(function (event) {
        const text = $(this).val();
        $tags.tagsinput('add', { id: text, name: text });
        $tags.tagsinput('input').val('');
      });

      // Format
      const menuItems = that.$wrapper.find('.ui-dropdown-items');
      const formats = INKIVE.Tool._cache.layoutFormat;
      that.$wrapper.find('[name="layout_format"]').val(data.format_id);

      for (let i = 0; i < formats.length; i++) {
        const displayWidth =
          formats[i].unit == 'px'
            ? parseInt(formats[i].width)
            : formats[i].width;
        const displayHeight =
          formats[i].unit == 'px'
            ? parseInt(formats[i].height)
            : formats[i].height;

        const name =
          formats[i].string_id +
          ' <small>(' +
          displayWidth +
          formats[i].unit +
          ' x ' +
          displayHeight +
          formats[i].unit +
          ')</small>';
        const item = $.parseHTML(
          '<li><a data-id="' +
            formats[i].id +
            '" data-width="' +
            formats[i].width +
            '" data-height="' +
            formats[i].height +
            '" data-unit="' +
            formats[i].unit +
            '">' +
            name +
            '</a></li>'
        );
        $(menuItems).append(item);

        if (
          formats[i].id == data.format_id ||
          (!data.format_id && formats[i].id == 1)
        ) {
          that.$wrapper.find('.ui-dropdown #layout_format').html(name);
          that.$wrapper.find('[name="layout_format"]').val(formats[i].id);

          that.$wrapper
            .find('[name="format_width"]')
            .val(
              INKIVE.Helpers.convertUnitsToPixels(
                formats[i].width,
                formats[i].unit
              )
            );
          that.$wrapper
            .find('[name="format_height"]')
            .val(
              INKIVE.Helpers.convertUnitsToPixels(
                formats[i].height,
                formats[i].unit
              )
            );
        }

        $(item)
          .find('a')
          .on('click', function () {
            that.$wrapper
              .find('[name="layout_format"]')
              .val($(this).attr('data-id'))
              .trigger('change');
            that.$wrapper
              .find('.ui-dropdown #layout_format')
              .html($(this).html());

            that.$wrapper
              .find('[name="format_width"]')
              .val(
                INKIVE.Helpers.convertUnitsToPixels(
                  $(this).attr('data-width'),
                  $(this).attr('data-unit')
                )
              );
            that.$wrapper
              .find('[name="format_height"]')
              .val(
                INKIVE.Helpers.convertUnitsToPixels(
                  $(this).attr('data-height'),
                  $(this).attr('data-unit')
                )
              );

            $(menuItems).hide();
          });
      }

      // Special cases if now format width and height
      if (!that.$wrapper.find('[name="layout_format"]').val()) {
        that.$wrapper.find('[name="format_width"]').val(data.format_width);
        that.$wrapper.find('[name="format_height"]').val(data.format_height);
      }

      that.$wrapper.find('.ui-dropdown .input-icon').on('click', function () {
        if ($(menuItems).css('display') == 'none') $(menuItems).show();
        else $(menuItems).hide();
      });

      // ////////
      // Checkboxes

      // Is text
      const checked = 'check';

      // Is active
      if (parseInt(data.active)) {
        that.$wrapper.find('[name="is_active"]').attr('checked', checked);
      }

      // Is active
      if (parseInt(data.is_premium)) {
        that.$wrapper.find('[name="is_premium"]').attr('checked', checked);
      }
    }

    function loadData (callback) {
      callback = callback || $.noop;

      INKIVE.Modal.loader(that.$wrapper);
      INKIVE.Tool.preloadLayoutFormat(function (status) {
        // Load data from server
        if (that.opts.id) {
          INKIVE.Helpers.api(
            'search/layout',
            'GET',
            { id: that.opts.id },
            function (r) {
              INKIVE.Modal.loaderClose(that.$wrapper);

              if (r && r.id) {
                setData(r || {});
                callback();
              } else {
                that.$wrapper.append(
                  'Error in loading layout ID ' + that.opts.id
                );
              }
            }
          );
        }
        // Load defalt data if defind in constructor
        // Used to duplicate a layout
        else if (that.opts.data) {
          INKIVE.Modal.loaderClose(that.$wrapper);
          setData(that.opts.data);

          callback();
        }
        // Use empty data for new layout
        else {
          INKIVE.Modal.loaderClose(that.$wrapper);
          setData({});

          callback();
        }
      });
    }
  }

  getFormHtml () {
    return this.$wrapper;
  }

  getData () {
    return this.data;
  }

  getFormData () {
    const tagsdata = this.$wrapper.find('[name="tags"]').tagsinput('items');
    const tags = [];
    for (let i = 0; i < tagsdata.length; i++) tags.push(tagsdata[i].id);

    return {
      id: this.data.id,
      name: this.$wrapper.find('[name="name"]').val(),
      set: this.$wrapper.find('[name="set"]').val(),
      orientation: 0,
      text: 1,
      isBackground: 1,
      num: 0,
      active: this.$wrapper.find('[name="is_active"]').is(':checked') ? 1 : 0,
      premium: this.$wrapper.find('[name="is_premium"]').is(':checked') ? 1 : 0,
      format_id: this.$wrapper.find('[name="layout_format"]').val(),
      format_width: this.$wrapper.find('[name="format_width"]').val(),
      format_height: this.$wrapper.find('[name="format_height"]').val(),
      tag: tags.join(',')
    };
  }

  saveForm (callback) {
    callback = callback || $.noop;
    const that = this;

    const info = that.getFormData();

    INKIVE.Helpers.api(
      'management/layoutinfo',
      'POST',
      {
        info
      },
      function (r) {
        if (r && r.status == 'success') {
          callback(true, $.extend(that.getData(), info, { id: r.id }));
        } else {
          INKIVE.Modal.alertMessage(
            '<b>Error - </b><i>Updating layout info</i><br>'
          );
          callback(false);
        }
      }
    );
  }

  deleteForm (callback) {
    callback = callback || $.noop;
    const that = this;

    const info = that.getFormData();

    INKIVE.Helpers.api(
      'management/layout',
      'DELETE',
      {
        id: info.id
      },
      function (r) {
        if (r && r.status == 'success') {
          callback(true);
        } else {
          INKIVE.Modal.alertMessage('<b>Error - </b><i>Delete layout</i><br>');
          callback(false);
        }
      }
    );
  }
}

module.exports = ModalAdminLayout;
